// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ErrorModal_wrap__UYTFZ","title":"ErrorModal_title__OXJJ8","reload":"ErrorModal_reload___7bQa"};